export namespace WithdrawalStatusId {
  export const Created = 1n;
  export const Pending = 2n;
  export const Paid = 3n;
  export const Expired = 4n;
  export const Rejected = 5n;
  export const Canceled = 6n;
  export const Failed = 7n;
  export const Refunded = 8n;
}

export type WithdrawalStatusIdType =
  | typeof WithdrawalStatusId.Created
  | typeof WithdrawalStatusId.Pending
  | typeof WithdrawalStatusId.Paid
  | typeof WithdrawalStatusId.Expired
  | typeof WithdrawalStatusId.Rejected
  | typeof WithdrawalStatusId.Canceled
  | typeof WithdrawalStatusId.Failed
  | typeof WithdrawalStatusId.Refunded;
